module.exports = __webpack_public_path__ + "img/20190418_154809_005.0fb655d4.jpg";